function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypescript(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M69.7 198.8H488v284.5H69.7z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2 2.9h473.6c10.6 0 19.2 8.5 19.2 19v468.3c0 10.5-8.6 19-19.2 19H19.2c-10.6 0-19.2-8.5-19.2-19V21.9c0-10.5 8.6-19 19.2-19m265.4 269.3v-41.5H102.4v41.5h65.1v184.9h51.8V272.2zm20.7 180c8.4 4.2 18.2 7.4 29.6 9.5s23.4 3.2 36.1 3.2c12.3 0 24-1.2 35.1-3.5q16.65-3.45 29.1-11.4c8.4-5.3 15-12.3 19.8-20.8s7.3-19.2 7.3-31.8c0-9.2-1.4-17.2-4.2-24.1s-6.8-13-12-18.4q-7.8-8.1-18.9-14.4c-11.1-6.3-15.6-8.3-24.8-12.1-6.7-2.7-12.8-5.4-18.1-8-5.4-2.6-9.9-5.2-13.7-7.9-3.7-2.7-6.6-5.5-8.7-8.5-2-3-3.1-6.4-3.1-10.2 0-3.5.9-6.6 2.7-9.4s4.4-5.2 7.7-7.2 7.4-3.6 12.2-4.7 10.2-1.7 16.1-1.7c4.3 0 8.8.3 13.6.9s9.6 1.6 14.4 2.9 9.5 3 14.1 5q6.9 3 12.6 6.9v-47.2c-7.8-2.9-16.4-5.1-25.6-6.6-9.3-1.4-19.9-2.1-31.9-2.1-12.2 0-23.8 1.3-34.7 3.9s-20.5 6.6-28.8 12.1-14.9 12.4-19.7 20.9-7.2 18.6-7.2 30.4c0 15.1 4.4 27.9 13.3 38.5q13.2 15.9 40.2 27 10.65 4.2 19.8 8.4c6.1 2.7 11.4 5.6 15.8 8.5s8 6.2 10.5 9.6c2.6 3.5 3.9 7.4 3.9 11.8 0 3.3-.8 6.3-2.4 9.1s-4 5.2-7.3 7.3-7.3 3.7-12.2 4.8c-4.9 1.2-10.6 1.7-17.1 1.7-11.1 0-22.2-1.9-33.1-5.8-10.9-3.8-21-9.6-30.4-17.3z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#3178c6"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypescript);
export default __webpack_public_path__ + "static/media/typescript.0f91ba288d4cf4b82cdf7ea04fd488ba.svg";
export { ForwardRef as ReactComponent };